/* eslint-disable no-await-in-loop */
import * as Sentry from '@sentry/react';
import { Address, PublicClient, TransactionReceipt, WalletClient } from 'viem';
import { waitForTransactionReceipt } from 'viem/actions';

interface IWaitForReceiptWithRetryParams {
  hash: Address;
  maxAttempts?: number;
  delayMs?: number;
}

const DEFAULT_MAX_ATTEMPTS = 30;
const DEFAULT_DELAY_MS = 200;
const UPDATE_DATA_DELAY_MS = 1000;

export async function waitForReceiptWithRetry(
  client: PublicClient | WalletClient,
  {
    hash,
    maxAttempts = DEFAULT_MAX_ATTEMPTS,
    delayMs = DEFAULT_DELAY_MS,
  }: IWaitForReceiptWithRetryParams,
): Promise<TransactionReceipt> {
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      const receipt = await waitForTransactionReceipt(client, { hash });

      await new Promise(resolve => setTimeout(resolve, UPDATE_DATA_DELAY_MS));

      return receipt;
    } catch (e) {
      if (attempt === maxAttempts) {
        Sentry.captureException(
          `Attempt ${attempt} failed:${(e as Error)?.message}`,
        );
      }

      await new Promise(resolve => setTimeout(resolve, delayMs));
    }
  }
  throw new Error('Receipt not found after maximum attempts');
}
